var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2520,
    height: 1700,
    viewBox: "0 0 2520 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M1382 388.441V696.5H1533V774.5H1525.5V858.879L1585.08 860V1020.57V1218.18V1263.32V1281.29V1316.29V1332.88V1397.83V1405.66H2141.52V303H2004.5V285H1926H1873H1742H1693H1647.5H1602H1557.5H1509H1382H1376L1374.5 368.5H1382V388.441Z",
    fill: "#FFD426",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M1046.42 392.111V671.713H1092.5V745.204V758.5H1156.51V859.901H843.283V1262.5V1280.46V1316.34V1332V1397.56V1407.23H679V1386.5L346.5 1388.61V1407.5H285V303H641.527V284.5H660.413H1052V357.354L1046.42 361.709V392.111Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.76378
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M843.5 1263.07V1280.12V1316.51V1332.63V1397.58V1405.87H1586.5V859.5H843.5V1051.18V1263.07Z",
    fill: "#FFD426",
    fillOpacity: 0.2,
    stroke: "#FFD426",
    strokeWidth: 2.76378
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor5);
export default __webpack_public_path__ + "static/media/select-floor-5.261d8874.svg";
export { ForwardRef as ReactComponent };